


export function validateClientName(name) {
    let formatName;

    if (!name) {
        return false;
    }

    formatName = name.trim().split(' ');

    const valid = formatName && formatName.length > 1 && formatName[0].length > 1 ? true : false;

    return valid;
}